import { z } from 'zod';

/**
 * R-04/R-05 — the only cart request body. Quantity 0 deletes the line, so there
 * is no separate delete endpoint needed for the common case. There is no price
 * field here on purpose (invariant 6, implementation spec §1) — a cart line
 * never carries a client-supplied price, only a code and a quantity.
 *
 * `size` (CR-44) and `remark` (CR-15) are optional — the catalog grid's compact
 * "Add" control has no UI for either and still sends a plain
 * `{variantCode, quantity}`; only the product-detail page's buy panel sets them.
 */
export const zSetCartLine = z.object({
  variantCode: z.string().min(1).max(64),
  quantity: z.number().int().min(0).max(100_000),
  size: z.string().max(32).optional(),
  remark: z.string().max(1000).optional(),
});
export type SetCartLine = z.infer<typeof zSetCartLine>;

/**
 * R-02's several-at-once table: one metal frame, a quantity typed beside any of
 * its stone specifications. Sent as one request because the alternative is one
 * round trip per row, and the whole point of the table is that a buyer picks
 * five or six at a time.
 *
 * Capped at the largest frame any product carries (Colette's 20), not at the
 * 180 a product can hold: this endpoint serves one frame's table, and a larger
 * body is a client doing something the screen cannot ask for.
 */
export const zSetCartLines = z.object({
  lines: z.array(zSetCartLine).min(1).max(40),
});
export type SetCartLines = z.infer<typeof zSetCartLines>;
